// extracted by mini-css-extract-plugin
export default {"sendButton":"LetterSendButton_sendButton__4sFto"};